<template>
  <div class="project-manage app-panel blank-h">
    <div class="app-control app-table-control">
      <el-button type="primary" @click="add">新增标签</el-button>
      <div class="right-region">
        <el-input placeholder="请输入ID或名称" v-model="search.name" clearable></el-input>
        <el-button type="primary" @click="searchParams">搜索</el-button>
        <el-button @click="resetParams">重置</el-button>
      </div>
    </div>
    <el-table :data="datas" v-loading="loading">
      <el-table-column label="ID" prop="project_external_staff_tag_id"></el-table-column>
      <el-table-column label="名称" prop="external_staff_tag_name"></el-table-column>
      <el-table-column label="描述" prop="external_staff_tag_description"></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="{row}">
          <el-button type="text" @click="edit(row.project_external_staff_tag_id)">编辑</el-button>
          <el-button type="text" @click="del(row.project_external_staff_tag_id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination :total="page.total" :page-size="page.pageSize" :current-page="page.currentPage" @current-change="currentChange" background></el-pagination>
  </div>
</template>

<script>
  import LabelService from '@/io/label.js';

  export default {
    name: 'ProjectManage',
    data() {
      return {
        search: {
          name: ''
        },
        datas: [],
        loading: false,
        page: {
          pageSize: 0,
          total: 0,
          currentPage: 1
        }
      }
    },
    mounted () {
      this.initDatas();
    },
    methods: {
      initDatas() {
        this.loading = true;
        LabelService.listPage(
          this.search.name,
          this.page.currentPage
        ).then(res => {
          let source = res.data.project_external_staff_tag_list;
          if (!source.data.length && this.page.currentPage > 1) {
            this.page.currentPage--;
            this.initDatas();
          } else {
            this.datas = source.data;
            this.page.pageSize = source.per_page;
            this.page.total = source.total;
          }
        }).catch(() => {}).finally(() => {
          this.loading = false;
        });
      },
      add() {
        this.$router.push({
          path: '/label_manage/new'
        });
      },
      edit(id) {
        this.$router.push({
          path: `/label_manage/edit/${id}`
        });
      },
      del(id) {
        this.$confirm(
          '确认删除?',
          '提示',
          {
            type: 'warning'
          }
        ).then(() => {
          return LabelService.del(id);
        }).then(res => {
          return this.initDatas();
        }).then(res => {
          this.$message.success('删除成功');
        }).catch(() => {});
      },
      currentChange(page) {
        this.page.currentPage = page;
        this.initDatas();
      },
      searchParams() {
        this.page.currentPage = 1;
        this.initDatas();
      },
      resetParams() {
        this.search.name = '';
        this.searchParams();
      }
    },
  }
</script>

<style lang="less" scoped>

</style>